<template>
  <Layout :footer-style="2">
    <div class="AboutUs">
      <div class="AboutUs_content">
        <StaticBanner :banner-date="bannerDate" is-black></StaticBanner>
        <div class="content_body">
          <!-- 关于博信诚 介绍部分 -->
          <!-- 使用 Bootstrap Grid 系统实现左右分栏布局，适配移动端 -->
          <div class="aboutNum" id="aboutNum" style="background: none; height: auto; padding: 50px 0;">
            <div class="container">
              <div class="row align-items-center">
                <!-- 左侧: 文本内容 & 数据统计 -->
                <!-- col-lg-6 在大屏幕占一半宽度, col-md-12 在中等屏幕全宽 -->
                <div class="col-lg-6 col-md-12 mb-5 mb-lg-0" data-aos="fade-right" data-aos-delay="100">
                  <!-- 标题 -->
                  <!-- <h3 class="aboutNum-title mb-4" style="color: #000; font-weight: bold; font-size: 2rem;">关于博信诚</h3> -->
                  <img style="height: 33px;" src="@/assets/newImages/aboutUs/关于博信城.png" alt="">
                  <!-- 介绍文本段落 -->
                  <div class="about-text mb-5" style="line-height: 1.8; font-size: 14px;">
                    <p class="mb-3" style="color: #576F8C;">
                      博信诚作为企业和公共组织提供智能服务的领导厂商，坚持“赋能业务增长、成就企业梦想”战略定位，具备业务和财务综合能力优势，拥有面向大型集团的元生AI平台、企业AI、医疗AI、BossinMind行业及企业专属大模型等核心产品及解决方案，助力企业战略可持续性发展，推动业务增长和盈利能力。
                    </p>
                  </div>

                  <Counter :counter-style="5" text-align="center" :counter-data="counterData" />
                </div>

                <!-- 右侧: 视频/图片展示区域 -->
                <div class="col-lg-6 col-md-12" data-aos="fade-left" data-aos-delay="200">
                  <!-- 外部白色卡片容器 -->
                  <div class="video-card-container"
                    style="padding: 15px; border-radius: 20px; max-width: 580px; margin: -30px auto 0;">
                    <!-- 内部视频容器 -->
                    <div class="video-wrapper position-relative" style="border-radius: 12px; overflow: hidden;">
                      <img src="@/assets/newImages/aboutUs/视频_mp4@2x.png" alt="About Bossint" class="w-100"
                        style="display: block; object-fit: cover; min-height: 250px;">
                      <!-- 播放按钮遮罩 -->
                      <div
                        class="play-btn-overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        @click="playVideo">
                        <!-- 播放图标 -->
                        <div class="play-icon bg-white rounded-circle d-flex justify-content-center align-items-center"
                          style="width: 80px; height: 80px; cursor: pointer; transition: transform 0.3s;">
                          <div
                            style="width: 0; height: 0; border-top: 10px solid transparent; border-bottom: 10px solid transparent; border-left: 18px solid #186BB3; margin-left: 5px;">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 视频播放弹窗 -->
            <transition name="fade">
              <div v-if="showVideoModal" class="video-modal-overlay" @click.self="closeVideoModal">
                <div class="video-modal-content">
                  <span class="close-btn" @click="closeVideoModal">&times;</span>
                  <video controls autoplay class="video-player">
                    <source :src="videoUrl" type="video/mp4">
                    您的浏览器不支持 video 标签。
                  </video>
                </div>
              </div>
            </transition>

            <!-- 新的发展历程组件 -->
            <historyLineNew :history-text="historyText" id="historyLine"></historyLineNew>

          </div>


        </div>

        <!-- 荣誉和资质 -->
        <div id="honorSection" class="honor-section" data-aos="fade-up">
          <div class="container">
            <div class="section-title" data-aos="fade-up" data-aos-delay="100">荣誉和资质</div>
            <p class="section-subtitle" data-aos="fade-up" data-aos-delay="200">为企业和公共组织提供智能服务的领导厂商</p>

            <div class="honor-list">
              <div class="honor-item-wrapper" v-for="i in 10" :key="i" data-aos="flip-up"
                :data-aos-delay="200 + (i * 50)">
                <div class="honor-item">
                  <div class="honor-img-box">
                    <img :src="require(`@/assets/newImages/aboutUs/荣誉_${String(i).padStart(2, '0')}@2x.png`)"
                      alt="荣誉资质">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 支持与服务 -->
        <div id="supportService" class="support-service" data-aos="fade-up">
          <div class="container">
            <div class="section-title" data-aos="fade-up" data-aos-delay="100">支持与服务</div>
            <p class="section-subtitle" data-aos="fade-up" data-aos-delay="200">为企业和公共组织提供智能服务的领导厂商</p>

            <div class="img-wrapper" data-aos="zoom-in" data-aos-delay="300">
              <img src="~@/assets/newImages/aboutUs/支持和服务@2x (1).png" alt="支持与服务" class="support-img">
            </div>
          </div>
        </div>

        <!-- 新闻动态 -->
        <div id="newsSection" class="news-section" data-aos="fade-up">
          <div class="container">
            <div class="section-title" data-aos="fade-up" data-aos-delay="100">新闻动态</div>
            <p class="section-subtitle" data-aos="fade-up" data-aos-delay="200">为企业和公共组织提供智能服务的领导厂商</p>

            <div class="news-list">
              <div class="news-item" v-for="(item, index) in newsData" :key="index" data-aos="fade-up"
                data-aos-delay="300" @click="goInformation(item.id)">
                <div class="news-img">
                  <img :src="item.titleimage" :alt="item.title">
                </div>
                <div class="news-content">
                  <div class="news-title">{{ item.title }}</div>
                  <div class="news-desc">{{ item.text }}</div>
                  <div class="news-meta">
                    <span class="news-source">来源：博信城云</span>
                    <span class="news-time">时间：{{ item.createtime }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="moreNews" data-aos="fade-up" data-aos-delay="500" class="more-news-btn" @click="moreNewsHandle">更多新闻</div>
          </div>
        </div>

        <!-- 加入我们 -->
        <div id="joinCta" class="join-cta" data-aos="fade-up">
          <div class="container">
            <div class="cta-content">
              <h3 class="cta-title" data-aos="fade-right" data-aos-delay="100">你是我们要寻找的人吗？</h3>
              <p class="cta-desc" data-aos="fade-right" data-aos-delay="200">
                欢迎加入博信诚，博信诚将成为您职业生涯中新的驿站，在您职业成长过程中我们将为您创造广阔的发展和机遇，也愿您能充分的展示和表现自己，发挥您的财能和潜能
              </p>
              <button class="cta-btn" data-aos="zoom-in" data-aos-delay="300" @click="joinUs">立即加入</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.AboutUs {
  margin: 0 auto;
  max-width: 1920px;

  .AboutUs_content {
    // margin-top: 80px;

    .join-cta {
      background: url(~@/assets/images/aboutUs/jiaruwmenbj.png) center/cover no-repeat;
      border-radius: 16px;
      min-height: 440px;
      padding: 40px 60px;
      display: flex;
      align-items: center;
    }

    .join-cta .cta-content {
      max-width: 560px;
    }

    .join-cta .cta-title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 12px;
      color: #152131;
    }

    .join-cta .cta-desc {
      line-height: 1.8;
      color: #5E748F;
      margin-bottom: 16px;
    }

    .join-cta .cta-btn {
      background: #1B75ED;
      border: none;
      border-radius: 4px;
      padding: 10px 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 14px;
      color: #FFFFFF;
    }

    /* 视频弹窗样式 */
    .video-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.85);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }

    .video-modal-content {
      position: relative;
      width: 90%;
      max-width: 1000px;
      background: #000;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 0 30px rgba(0,0,0,0.5);
    }

    .video-player {
      width: 100%;
      max-height: 80vh;
      display: block;
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 20px;
      color: #fff;
      font-size: 36px;
      cursor: pointer;
      z-index: 10001;
      line-height: 1;
      text-shadow: 0 0 10px rgba(0,0,0,0.5);
      transition: transform 0.3s;
      &:hover {
        transform: scale(1.1);
      }
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.3s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

    .honor-section {
      padding: 80px 0;
      background: #F8FBFF;
      text-align: center;

      .section-title {
        font-family: Alibaba-PuHuiTi-B;
        font-weight: bold;
        font-size: 24px;
        color: #152131;
        letter-spacing: 0;
        line-height: 34px;
      }

      .section-subtitle {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #657C99;
        margin-bottom: 50px;
      }

      .honor-list {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        justify-content: center;
      }

      .honor-item-wrapper {
        width: calc((100% - 160px) / 5);

        .honor-item {
          width: 100%;
          height: 100%;
          // background: #FFFFFF;
          // box-shadow: 0 4px 20px 0 rgba(27, 117, 237, 0.08);
          // border-radius: 8px;
          // padding: 30px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          cursor: pointer;
          // min-height: 160px;

          &:hover {
            transform: translateY(-10px);
            box-shadow: 0 10px 30px 0 rgba(27, 117, 237, 0.15);
          }

          .honor-img-box {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }
          }
        }
      }

      @media (max-width: 1200px) {
        .honor-item-wrapper {
          width: calc((100% - 60px) / 4);
        }
      }

      @media (max-width: 992px) {
        .honor-item-wrapper {
          width: calc((100% - 40px) / 3);
        }
      }

      @media (max-width: 768px) {
        .honor-item-wrapper {
          width: calc((100% - 20px) / 2);
          
          .honor-item {
            min-height: 120px;
            padding: 15px;
          }
        }
      }
    }

    .support-service {
      padding: 80px 0;
      text-align: center;

      .section-title {
        font-family: Alibaba-PuHuiTi-B;
        font-weight: bold;
        font-size: 24px;
        color: #152131;
        letter-spacing: 0;
        line-height: 34px;
      }

      .section-subtitle {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #657C99;
        margin-bottom: 50px;
      }

      .img-wrapper {
        display: flex;
        justify-content: center;

        .support-img {
          max-width: 80%;
          height: auto;
        }
      }
    }

    .news-section {
      padding: 60px 0 42px 0;
      text-align: center;
      background: url(~@/assets/newImages/aboutUs/新闻背景_bj@2x.png) center/cover no-repeat;

      .section-title {
        font-family: Alibaba-PuHuiTi-B;
        font-weight: bold;
        font-size: 24px;
        color: #152131;
        letter-spacing: 0;
        line-height: 34px;
      }

      .section-subtitle {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #657C99;
        margin-bottom: 50px;
      }
      .more-news-btn{
        width: fit-content;
        margin: 0 auto;
        margin-top: 32px;
        border: 1px solid #5B6F8A;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #5B6F8A;
        padding: 6px 20px;
        cursor: pointer;
        &:hover {
          border: 1px solid #1B75ED;
          color: #1B75ED;
        }
      }
      .news-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }

      .news-item {
        display: flex;
        background: #FFFFFF;
        padding: 16px;
        text-align: left;
        border: 1px solid #F5F8FC;
        box-shadow: 0 0 16px 0 #1867f114;
        border-radius: 6px;
        cursor: pointer;

        &:hover {
          box-shadow: 0 0 20px 0 #1867f138;
        }

        .news-img {
          width: 119.85px;
          height: 86px;
          flex-shrink: 0;
          margin-right: 20px;
          border-radius: 4px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .news-content {
          flex: 1;

          .news-title {
            font-weight: bold;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            font-size: 16px;
            color: #212D3D;
            letter-spacing: 0;
          }

          .news-desc {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #5B6F8A;
            letter-spacing: 0;
            margin-bottom: 17px;
          }

          .news-meta {
            font-size: 12px;
            color: #869FBC;

            .news-source {
              margin-right: 20px;
            }
          }
        }
      }
    }

    .titles {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #F6F7FA;

      .in_titles {
        display: flex;
        max-width: 1440px;
        height: 70px;
        width: 100%;
        padding: 0 70px;
        align-items: center;

        .in_titles_left {
          display: flex;
          width: 50%;
          align-items: center;
          margin-left: 5%;

          .in_titles_left_img {
            height: 30%;
            margin-right: 10px;
          }
        }

        .in_titles_right {
          display: flex;
          flex: 1;
          justify-content: space-around;

          a {
            color: #12294f;
            padding: 20px 0;
            cursor: pointer;
          }

          .changes {
            color: #186BB3;
            border-bottom: 4px solid #186BB3;
          }
        }
      }
    }

    .content_body {
      .aboutNum {
        background: url("../assets/images/aboutUs/bg-num.png");
        height: 650px;

        .aboutNum_text {
          margin: 0 13%;

          .aboutNum-title {
            padding-top: 10%;
          }

          .aboutNum-content {
            width: 80%;
          }
        }
      }

      .ecoPartners {
        margin-top: 3rem;
        background: url("../assets/images/aboutUs/partner-bg.png");
        min-height: 450px;

        .ecoPartners_content {
          .ecoPartners-text {
            .text-title {}

            .text-p {
              width: 50%;
              margin: 20px auto;
            }
          }

          .ecoPartners-list {
            display: flex;
            justify-content: center;

            .card-text {
              position: absolute;
              top: 35%;
              left: 40%;

              img {
                width: 70px;
                height: 70px;
              }

              div {
                color: rgb(0, 91, 171);
                margin: 15px 0;
              }
            }

            .list_card {
              background: url("../assets/images/aboutUs/partner-sl1.jpg") no-repeat;
              height: 400px;
              width: 316px;
              position: relative;
              transition: all 1s;

              .card-hover {
                display: none;
              }

              &:hover {
                background: url("../assets/images/aboutUs/partner1.jpg") no-repeat;
                height: 400px;
                width: 800px;

                .card-text {
                  display: none;
                }

                .card-hover {
                  display: block;
                  margin: 30% 0 0 10%;
                }
              }
            }

            .list_card2 {
              background: url("../assets/images/aboutUs/partner-sl2.jpg") no-repeat;
              height: 400px;
              width: 316px;
              position: relative;
              transition: all 1s;

              .card-hover {
                display: none;
              }

              &:hover {
                background: url("../assets/images/aboutUs/partner2.jpg") no-repeat;
                height: 400px;
                width: 800px;
                transition: all 1s;

                .card-text {
                  display: none;
                }

                .card-hover {
                  display: block;
                  margin: 30% 0 0 10%;
                }
              }
            }

            .list_card3 {
              background: url("../assets/images/aboutUs/partner-sl3.jpg") no-repeat;
              height: 400px;
              width: 300px;
              position: relative;
              transition: all 1s;

              .card-hover {
                display: none;
              }

              &:hover {
                background: url("../assets/images/aboutUs/partner3.jpg") no-repeat;
                height: 400px;
                width: 800px;
                transition: all 1s;

                .card-text {
                  display: none;
                }

                .card-hover {
                  display: block;
                  margin: 30% 0 0 10%;
                }
              }
            }
          }

          .ecoPartners-list-phone {
            flex-wrap: wrap;

            .list_card,
            .list_card2,
            .list_card3 {
              width: 100%;
              height: 20rem;
              position: relative;

              .card-hover {
                display: block;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                margin: 0 10%;

                .hover-text {
                  display: block;
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  margin-bottom: 1rem;

                  img {
                    margin-right: 1rem;
                  }
                }
              }
            }

            .list_card {
              background: url('../assets/images/aboutUs/partner1.jpg') no-repeat center;
            }

            .list_card2 {
              background: url('../assets/images/aboutUs/partner2.jpg') no-repeat center;
            }

            .list_card3 {
              background: url('../assets/images/aboutUs/partner3.jpg') no-repeat center;
            }
          }

          .join-btn {
            width: 12rem;
            height: 4rem;
            font-size: 12px;
            border-color: #fff;
          }
        }
      }

      .join_us {
        text-align: center;
        margin-bottom: 20px;

        .join_us_h {

          h3,
          h4 {
            margin: 0;
          }
        }

        .join_us_main {
          max-height: 655px;
          max-width: 1440px;
          position: relative;
          margin: 0 auto;

          .join_us_img {
            img {
              min-height: 555px;
            }
          }

          .join_us_text {
            position: absolute;
            top: 33%;
            left: 13%;
            margin-right: 13%;
            width: 60%;
            text-align: left;

            .join_us_title {
              position: relative;
              margin-bottom: 35px;

              img {
                position: absolute;
                bottom: -7px;
                left: 0;
              }

              h3 {
                position: relative;
                z-index: 5;
              }
            }

            .join_us-content {
              font-size: 1.5rem;
              margin: 10px 0;
            }

            .join_us-btn {
              margin-top: 2rem;
              width: 12rem;
              height: 4rem;
              border-color: #fff;

              &:hover {}
            }
          }
        }
      }
    }
  }
}
</style>
<script>
import $ from 'jquery'
import Layout from '../components/common/Layout'
import StaticBanner from "@/components/common/staticBanner/index.vue"
import Counter from "@/components/common/Counter"
import honorSwipe from "@/components/common/honorSwipe/index.vue"
import historyLineNew from "@/components/common/honorSwipe/historyLineNew.vue"
import dropdownMenu from "@/components/common/dropdownMenu.vue"
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "AboutUs",
  components: { StaticBanner, Counter, Layout, honorSwipe, historyLineNew, swiper, swiperSlide, dropdownMenu },
  data() {
    return {
      menus: [],
      swiperOption: {
        speed: 1000,
        slidesPerView: 1,
        // centeredSlides: true,
        // spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 20000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
      },
      bannerDate: {
        url: require("@/assets/newImages/aboutUs/aboutus.png"),
        // title: "关于博信诚云",
        // content: "十余年专注为中高端客户提高全场景一站式的智慧业财一体化服务",
        title: "博信诚为企业和公共组织<br/>提供智能服务的领导厂商",
        content: "10余年专注为中高端客户提供全场景、一站式的智能化服务。",
        btn: false,
      },
      counterData: [
        {
          number: 2012,
          title: "公司创建于2012年",
          title2: "业财一体化服务"
        },
        {
          number: 500,
          title: "大型集团企业",
          title2: "共同选择"
        },
        {
          number: 2000,
          title: "成长型企业",
          title2: "共同选择"
        },
      ],
      historyText: [
        {
          times: "2012",
          works: [
            { work: "公司成立" },
            { work: "协同办公平台发版" },
            { work: "财务共享平台发版" },
          ],
        },
        {
          times: "2014",
          works: [
            { work: "中国国旅财务共享咨询实施项目" },
            { work: "构建中国国旅国内及海外资金池" },
            { work: "财务共享实施方法论发布" },
          ],
        },
        {
          times: "2015",
          works: [
            { work: "中国国旅实时报表一键合并项目" },
            { work: "增值税、影像、合同等产品发版" },
            { work: "" },
          ],
        },
        {
          times: "2017",
          works: [
            { work: "上海宝冶财务共享项目" },
            { work: "共享中台发布" },
            { work: "" },
          ],
        },
        {
          times: "2018",
          works: [
            { work: "上海宝冶财务共享中心获得CGMA大奖" },
            { work: "RPA平台发版网银机器人" },
            { work: "中国财政部最佳共享服务商" },
          ],
        },
        {
          times: "2019",
          works: [
            { work: "中梁集团财务共享项目" },
            { work: "通过国家工信部财务共享平台技术检验及并发测试" },
            { work: "" },
          ],
        },
        {
          times: "2020",
          works: [
            { work: "成长型企业云平台发版" },
            { work: "中国企业首选品牌" },
            { work: "最佳厂商奖" },
          ],
        },
        {
          times: "2021",
          works: [
            { work: "项目财务管理、收入管理、智慧网银等产品发版" },
            { work: "2021中国企业上云数智化平台服务领军企业" },
            { work: "" },
          ],
        },
        {
          times: "2022",
          works: [
            { work: "2022荣获“中国业财一体化云服务领航企业”大奖" },
            { work: "财务共享（中台）升级" },
            { work: "" },
          ],
        },
        {
          times: "2023",
          works: [
            { work: "荣获“2022中国企业智慧业财服务商首选品牌”大奖" },
            { work: "集团智慧企业云EECloud、成长企业云ESCloud全新升级" },
            { work: "" },
          ],
        },
        {
          times: "2024",
          works: [
            { work: "博信诚智慧业财云（ESCloud)入选中小企业服务券产品名单" },
            { work: "Ecoplace数据产业平台发布" },
            { work: "成长企业云ESCloud行业化应用-项目管理发布" },
          ],
        },
        {
          times: "2025",
          works: [
            { work: "为企业和公共组织提供智能服务的领导厂商" },
            { work: "元生AI平台、企业AI、医疗AI、BossinMind行业及企业专属大模型" }
          ],
        }
      ],
      val: '1',
      windowWidth: document.documentElement.clientWidth,
      newsData: [],
      showVideoModal: false,
      videoUrl: 'http://bossint.com.cn/video/2026%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E7%89%87720P.mov',
      moreNews: false,//更多新闻按钮是否展示
    }
  },
  mounted() {
    this.getNewsData(3)
    //获取路由query参数
    // 检查是否有id参数
    let id = this.$route.query.id
    if (id) {
      this.val = id
      this.a_Href()
    }
  },
  watch: {
    //获取路由query参数
    $route(to, from) {
      let id = to.query.id
      if (id) {
        this.val = id
        this.a_Href()
      }
    }
  },
  methods: {
    // 统一滚动函数，所有定位都上移50px
    scrollToElement(selector) {
      const element = document.querySelector(selector);
      if (element) {
        const elementTop = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementTop - 50;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    
    a_Href() {
      if (this.val == '1') {
        this.scrollToElement("#aboutNum");
      }
      if (this.val == '2') {
        this.scrollToElement("#honorSection");
      }
      if (this.val == '3') {
        this.scrollToElement("#supportService");
      }
      if (this.val == '4') {
        this.scrollToElement("#newsSection");
      }
      if (this.val == '5') {
        this.scrollToElement("#joinCta");
      }
    },
    joinParent() {
      this.$router.push({
        path: '/join-partners'
      })
    },
    joinUs() {
      window.open("https://www.zhipin.com/gongsi/b8f0378db6c7b1e41HN609W9Eg~~.html?ka=search_rcmd_company_b8f0378db6c7b1e41HN609W9Eg~~_custompage")
    },
    goInformation(id) {
      this.$router.push({
        path: "/information-details/" + id
      })
    },
    playVideo() {
      this.showVideoModal = true
    },
    closeVideoModal() {
      this.showVideoModal = false
    },
    getNewsData(page) {
      var ts = this
      $.ajax({
        type: "post",
        data: JSON.stringify({}),
        url: `http://120.53.104.103/bossint/findAllNewsPage/0/${page}`,
        dataType: "json",
        contentType: "application/json;charset=UTF-8",
        success: function (res) {
          ts.newsData = res.content
          // 当总条数大于3条时且未点击更多新闻时 才展示更多新闻按钮
          if (res.totalElements > 3 && page == 3) {
            ts.moreNews = true
          } else {
            ts.moreNews = false
          }
        },
        error: function () {
          // alert("出错啦...")
        },
      })
    },
    moreNewsHandle() {
      this.getNewsData(999)
    }
  },
}
</script>